import { H4, Spinner } from "@blueprintjs/core"

import { ToastError } from "../../components"
import { ContentColumn, HeaderRow, MutedHeading, PageContainer } from "./Models.styled"
import { ModelsTable } from "./ModelsTable"
import { usePublishedModels } from "./hooks/useModelsQueries"

/**
 * The directory of models available online: every yantra model published to
 * view.scient.io. Rows link out to the published page, which carries its own
 * session and saves back to the platform.
 */
const Models = () => {
  const { directory, error, isLoading } = usePublishedModels()

  if (isLoading) return <Spinner />
  if (error) return <ToastError error={error} errorMessage="Unable to load the model directory." />

  const models = directory?.models ?? []

  return (
    <PageContainer>
      <ContentColumn>
        <HeaderRow>
          <H4>Models</H4>
          <MutedHeading>{models.length} published on view.scient.io</MutedHeading>
        </HeaderRow>
        <ModelsTable models={models} />
      </ContentColumn>
    </PageContainer>
  )
}

export default Models
